<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <Adminheader></Adminheader>
        <section class="mt-3">
            <mdb-row>
                <mdb-col>
                    <h2>Aujourd'hui</h2>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <!--Grid column-->
                <mdb-col xl="4" md="6" class="mb-4">
                    <nbinscriptioncard></nbinscriptioncard>
                </mdb-col>
                <mdb-col xl="4" md="6" class="mb-4">
                    <nbuniqueviewerscard></nbuniqueviewerscard>
                </mdb-col>
                <mdb-col xl="4" md="6" class="mb-4">
                    <nbviewedminutescard/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <h2>Statistiques (30 derniers jours)</h2>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-line-chart
                            :data="UserslineChartData"
                            :options="lineChartOptions"
                            :width="1100"
                            :height="300"
                            v-if="UserslineChartData.datasets[0].data.length"
                    ></mdb-line-chart>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-line-chart
                            :data="MinutesViewedlineChartData"
                            :options="lineChartOptions"
                            :width="1100"
                            :height="300"
                            v-if="MinutesViewedlineChartData.datasets[0].data.length"
                    ></mdb-line-chart>
                </mdb-col>
            </mdb-row>
        </section>
        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>
    </mdb-container>
</template>
<script>
    import Vedheader from '@/components/Header.vue';
    import nbinscriptioncard from '@/components/nbinscriptionscard.vue';
    import nbuniqueviewerscard from '@/components/nbuniqueviewerscard.vue';
    import nbviewedminutescard from '@/components/nbviewedminutescard.vue';
    import Adminheader from '@/components/Adminheader.vue';
    import {
        mdbContainer,
        mdbFooter,
        mdbCol,
        mdbRow,
        mdbLineChart,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Admin',
        components: {
            Vedheader,
            mdbContainer,
            mdbFooter,
            mdbCol,
            mdbRow,
            nbinscriptioncard,
            Adminheader,
            nbuniqueviewerscard,
            nbviewedminutescard,
            mdbLineChart,
        },
        data() {
            return {
                UserslineChartData: {
                    labels: [
                    ],
                    datasets: [
                        {
                            label: 'Utilisateurs',
                            backgroundColor: 'rgba(255, 99, 132, 0.1)',
                            borderColor: 'rgba(255, 99, 132, 1)',
                            borderWidth: 0.7,
                            data: [],
                        },
                    ],
                },
                MinutesViewedlineChartData: {
                    labels: [
                    ],
                    datasets: [
                        {
                            label: 'Minutes visionnées',
                            backgroundColor: 'rgba(255, 99, 132, 0.1)',
                            borderColor: 'rgba(255, 99, 132, 1)',
                            borderWidth: 0.7,
                            data: [],
                        },
                    ],
                },
                lineChartOptions: {
                    responsive: true,
                    maintainAspectRatio: true,
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: 'rgba(0, 0, 0, 0.1)',
                                },
                            },
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: 'rgba(0, 0, 0, 0.1)',
                                },
                            },
                        ],
                    },
                },
            };
        },
        mounted() {
            this.getAndDisplayFormations();
        },
        methods: {
            getAndDisplayFormations() {
                const api = new Apicall();
                const self = this;
                api.getformationsStats().then((response) => {
                    if (response.data.status === 'OK') {
                        self.UserslineChartData.labels = response.data.dates;
                        self.MinutesViewedlineChartData.labels = response.data.dates;
                        self.UserslineChartData.datasets[0].data = response.data.viewers;
                        self.MinutesViewedlineChartData.datasets[0].data = response.data.minutesviewed;
                        console.log(self.UserslineChartData);
                    } else {
                        self.error = response.msg;
                    }
                    self.isLoading = false;
                });
            },
        },
    };
</script>
<style scoped>

</style>
